import { render, staticRenderFns } from "./SettingsDB.vue?vue&type=template&id=b0c93816&"
import script from "./SettingsDB.vue?vue&type=script&lang=js&"
export * from "./SettingsDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports